<template>
     <div class="vx-col w-full mb-base">
        <div class="vx-row">
            <div class="vx-col w-full mb-2">
                <vs-input class="w-full" label-placeholder="CSOSN" v-model="product.imposto.icms.CSOSN" />
            </div>
            <div class="vx-col w-full mb-2">
                <vs-input class="w-full" label-placeholder="CFOP" v-model="product.prod.CFOP" />
            </div>
        </div>
        <div class="vx-row">
            <div class="vx-col w-full mb-2">
                <vs-input class="w-full" label-placeholder="NCM" v-model="product.prod.NCM" />
            </div>
            <div class="vx-col w-full mb-2">
                <vs-input class="w-full" label-placeholder="cEAN" v-model="product.prod.cEAN" />
            </div>
        </div>
        <!-- <div class="vx-row">
            <div class="vx-col w-full mb-2">
                <vs-input class="w-full" label-placeholder="Company" v-model="input29" />
            </div>
            <div class="vx-col w-full mb-6">
                <vs-input type="email" class="w-full" label-placeholder="Email" v-model="input30" />
            </div>
        </div>
        <div class="vx-row">
            <div class="vx-col w-full mb-6">
                <vs-checkbox class="inline-flex" v-model="check7">Remember Me</vs-checkbox>
            </div>
        </div>
        -->
    </div>

</template>

<script>
    export default {
        props: {
            product: {
                type: Object,
            },
        },
    }
</script>

<style lang="scss" scoped>

</style>